import { render, staticRenderFns } from "./zaiban.vue?vue&type=template&id=765b48ee&scoped=true&"
import script from "./zaiban.vue?vue&type=script&lang=js&"
export * from "./zaiban.vue?vue&type=script&lang=js&"
import style0 from "./zaiban.vue?vue&type=style&index=0&id=765b48ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765b48ee",
  null
  
)

export default component.exports